/*
{
    id:
    slug:
    mainTitle:
    mainImg:
    meta: {
      authorName:
      date:
      by:
      mainCategory:
    },
    content: [
      {
        type: html
        data:
      },
      {
        type: tagline 
        data:
      }
    ],
    category: [
      // list of category tags
    ]
    actions: [
      {
        classNames:
        name:
        link:
        icon:
      }
    ],
    related: [
      {
        name:
        link:
      }
    ],
    author: {
      link:
      img:
      name:
      info:
    },
    navigation:{
      prev: { 
        name:
        link:
      }
      next: {
        name:
        link:
      }
    },
    allowComments: true,
    comments: {
      total:
      list: [
        id:
        name:
        comment:
        info:
        postByAuthor:
        reply: [
          id:
          name:
          email:
          postByAuthor:
          comment:
          reply: []
        ]
      ]
    },
  }
  */
export default {
  id: 1234,
  slug: "demo-blog",
  mainTitle: "This is main title",
  mainImg: "https://loremflickr.com/320/240",
  meta: {
    authorName: "john Doe",
    date: moment.utc().format(), // UTC time stamp
    mainCategory: "Category A"
  },
  content: [
    {
      type: "html",
      data: `<p class="drop-cap">
            One morning, when Gregor Samsa woke from troubled dreams, he found
            himself transformed in his bed into a horrible vermin. He lay on his
            armour-like back, and if he lifted his head a little he could see
            his brown belly, slightly domed and divided by arches into stiff
            sections. The bedding was hardly able to cover it and seemed ready
            to slide off any moment. His many legs, pitifully thin compared with
            the size of the rest of him, waved about helplessly as he looked.
          </p><p>
            "What's happened to me?" he thought. It wasn't a dream. His room, a
            proper human room although a little too small, lay peacefully
            between its four familiar walls. A collection of textile samples lay
            spread out on the table - Samsa was a travelling salesman - and
            above it there hung a picture that he had recently cut out of an
            illustrated magazine and housed in a nice, gilded frame. It showed a
            lady fitted out with a fur hat and fur boa who sat upright, raising
            a heavy fur muff that covered the whole of her lower arm towards the
            viewer. Gregor then turned to look out the window at the dull
            weather. Drops of rain could be heard hitting the pane, which made
            him feel quite sad. "How about if I sleep a little bit longer and
            forget all this nonsense", he thought, but that was something he was
            unable to do because he was used to sleeping on his right, and in
            his present state couldn't get into that position. However hard he
            threw himself onto his right, he always rolled back to where he was.
            He must have tried it a hundred times, shut his eyes so that he
            wouldn't have to look at the floundering legs, and only stopped when
            he began to feel a mild, dull pain there that he had never felt
            before.
          </p><p>
            Lorem ipsum dolor sit amet,
            <em>emphasis</em> consectetuer adipiscing elit. Nullam dignissim
            convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis
            suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at,
            tincidunt nec, gravida vehicula, nisl. Praesent mattis, massa quis
            luctus fermentum, turpis mi volutpat justo, eu volutpat enim diam
            eget metus. Maecenas ornare tortor. Donec sed tellus eget sapien
            fringilla nonummy. Mauris a ante. Suspendisse quam sem, consequat
            at, commodo vitae, feugiat in, nunc. Morbi imperdiet augue quis
            tellus.
          </p>`
    },
    {
      type: "code",
      title: "html",
      data: `<meta charset="utf-8" />;
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">;
          <meta name="description" content="impressiVcard - impressiVCard Responsive HTML5 VCard Template">
          <meta name="keywords" content="impressivcard, vcard, html5, ,portfolio">;
          <meta name="author" content="Pixelwars">;
          <title>ImpressivCard</title>`
    },
    {
      type: "html",
      data: `<h5>Adaptive Design</h5>
        <p>
          <img
            src="https://loremflickr.com/320/240"
            alt="Image"
            class="alignright"
          />This is some <a href="#" title="test link">test link</a> that will wrap around the image that sits on the
          right side of the text that you are writing about the leaf that is
          there. That is, if you are writing about leaves in the first place
          and you want to write about this specific leaf. Lorem ipsum dolor
          sit amet, <em>emphasis</em> consectetuer adipiscing elit. Nullam
          dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc
          iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi,
          imperdiet at, tincidunt nec, gravida vehicula, nisl. Praesent
          mattis, massa quis luctus fermentum, turpis mi volutpat justo, eu
          volutpat enim diam eget metus. Maecenas ornare tortor. Donec sed
          tellus eget sapien fringilla nonummy. Mauris a ante. Suspendisse
          quam sem, consequat at, commodo vitae, feugiat in, nunc. Morbi
          imperdiet augue quis tellus. Donec faucibus. Nunc iaculis suscipit
          dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt
          nec, gravida vehicula, nisl. Praesent mattis, massa quis luctus
          fermentum, turpis mi volutpat justo, eu volutpat enim diam eget
          metus. Maecenas ornare tortor. Donec sed tellus eget sapien
          fringilla nonummy. Mauris a ante. Suspendisse quam sem, consequat
          at, commodo vitae, feugiat in, nunc. Morbi imperdiet augue quis
          tellus.
        </p>`
    },
    {
      type: "code",
      data: `<meta charset="utf-8" />;
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">;
      <meta name="description" content="impressiVcard - impressiVCard Responsive HTML5 VCard Template">
      <meta name="keywords" content="impressivcard, vcard, html5, ,portfolio">;
      <meta name="author" content="Pixelwars">;
      <title>ImpressivCard</title>`
    },
    {
      type: "tagline",
      data: `
        This is a responsive template for showing what you think to
        everyone in the world, in any device. It's that simple!
      `
    },
    {
      type: "html",
      data: "This is the end of the blog."
    }
  ],
  category: [
    // list of category tags
    "Category A",
    "category B",
    "category C"
  ],
  actions: [
    {
      color: "blue",
      name: "name A",
      link: "http://www.google.com",
      icon: "fas fa-cloud-download-alt"
    },
    {
      color: "grass",
      name: "name B",
      link: "http://www.google.com",
      icon: "fa fa-eye"
    }
  ],
  related: [
    {
      name: "related post A",
      link: "http://www.google.com"
    },
    {
      name: "related post B",
      link: "http://www.google.com"
    }
  ],
  author: {
    link: "http://www.google.com",
    img: "https://loremflickr.com/320/240",
    name: "John Doe",
    info: `
        Johnny Doe was born in Ulm, in the Kingdom of Württemberg in the
        German Empire on 14 March 1879. His father was Hermann Einstein, a
        salesman and engineer. His mother was Pauline Einstein (née Koch).
      `
  },
  navigation: {
    prev: {
      name: "prevoious blog",
      link: "/blogA"
    },
    next: {
      name: "next blog",
      link: "blogB"
    }
  },
  allowComments: true,
  comments: {
    total: 4,
    list: [
      {
        id: 1,
        name: "john A",
        postByAuthor: true,
        message: "this is first comment",
        timeStamp: moment.utc().format(),
        reply: [
          {
            id: 2,
            name: "john C",
            timeStamp: moment.utc().format(),
            message: "this is reply to first comment"
          }
        ]
      },
      {
        id: 12,
        name: "john B",
        message: "hello there!",
        timeStamp: moment.utc().format(),
        reply: [
          {
            id: 1,
            name: "john A",
            message: "this is first comment",
            timeStamp: moment.utc().format(),
            postByAuthor: true,
            reply: [
              {
                id: 2,
                name: "john C",
                timeStamp: moment.utc().format(),
                message: "this is reply to first comment"
              }
            ]
          }
        ]
      }
    ]
  }
};
